@if (richTextHtml) {
  <div class="text" [ngClass]="{ 'on-background': onBackground }" [innerHTML]="richTextHtml"></div>
}
